import { render, staticRenderFns } from "./AppBreadcrumb.vue?vue&type=template&id=5819f8ea&scoped=true&"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./AppBreadcrumb.vue?vue&type=style&index=0&id=5819f8ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5819f8ea",
  null
  
)

export default component.exports